import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Offcanvas, Modal, Navbar, Nav, Button } from "react-bootstrap";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { logoutUser } from "../redux/auth/actions";
import { getUserBet } from "../redux/sports/actions";
import numberWithCommas from "../utils/numbersWithComma";

import logo from "../assets/images/logo.webp";
import StaticLogo from "../assets/images/staticlogo.png";
import Casino1 from "../assets/images/games-icon/casinoezugi-icon.webp";
import Evolution from "../assets/images/games-icon/Ezugi.webp";
import Slots1 from "../assets/images/games-icon/Slots.webp";
import ProfileIcon from "../assets/svg/ProfileIcon";
import BetIcon from "../assets/svg/BetIcon";
import StatementIcon from "../assets/svg/StatementIcon";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/refferal.png";
import LogoutIcon from "../assets/svg/LogoutIcon";
import WhatsappIcon1 from "../assets/images/icons/whatsap.png";
import TelegramIcon1 from "../assets/images/icons/instagram.png";
import Sports from "../assets/images/icons/head-menu/sports.svg";
import LiveCasino from "../assets/images/icons/head-menu/live-casino.svg";
import Casino from "../assets/images/icons/head-menu/casino.svg";
import Promotion from "../assets/images/icons/head-menu/promotion.svg";
import MenuToggle from "../assets/images/icons/menuLeft.svg";
import LeftMenuBar from "./LeftMenuBar";
import ThemeToggle from "./ThemeToggle";

const HeaderAfterLogin = () => {
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const [showLeftbar, setShowLeftbar] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const checkIfActive = (url) => {
    const path = window?.location?.pathname;
    return path?.indexOf(url) > -1 ? "active" : "";
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="leftbar-toggle me-3 d-lg-none">
                      <Button onClick={() => setShowLeftbar(true)}>
                        <img src={MenuToggle} alt="menu toggle" />
                      </Button>
                    </div>
                    <div className="logo">
                      <a href="/home">
                        {/* <img src={appDetails?.LOGO_URL} alt="Logo" /> */}
                        <img src={logo} alt="Logo" />
                      </a>
                    </div>
                  </div>

                  <div className="staticLogo">
                    <img src={StaticLogo} />
                  </div>

                  <Navbar expand="lg" className="d-none d-lg-block">
                    {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav>
                        <Nav.Link
                          href="/live-casino"
                          className={checkIfActive("/live-casino")}
                        >
                          <img src={LiveCasino} alt="bottom head link icon" />
                          <span>Live Casino</span>
                        </Nav.Link>
                        <Nav.Link
                          href="/casino"
                          className={checkIfActive("/casino")}
                        >
                          <img src={Casino} alt="bottom head link icon" />
                          <span>Virtual Casino</span>
                        </Nav.Link>
                        <Nav.Link
                          href="/sportsbook"
                          className={checkIfActive("/sportsbook")}
                        >
                          <img src={Sports} alt="Sportsbook" />{" "}
                          <span>Sportsbook</span>
                        </Nav.Link>
                        <Nav.Link
                          href="/sports/Cricket"
                          className={checkIfActive("/sports/Cricket")}
                        >
                          <img src={Sports} alt="Exchange Icon" width={20} />{" "}
                          <span>Exchange</span>
                        </Nav.Link>
                        {/* <Nav.Link href="#">
                          <img src={Promotion} alt="bottom head link icon" />
                          <span>Promotions</span>
                        </Nav.Link> */}
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar>

                  <div className="headerRight">
                    <ThemeToggle />

                    <Dropdown align="end" className="me-2">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        Bal: <span>{numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:{user?.mobileno}">
                          <b>{user?.mobileno}</b>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Balance</h6>
                          <span>
                            INR {numberWithCommas(wallet?.balance || 0)}
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="javascript:void(0)"
                          onClick={() => setShowBetModal(true)}
                        >
                          <h6>Cash</h6>
                          <span>INR {numberWithCommas(wallet?.cash || 0)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Coins</h6>
                          <span>INR {numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/gatewaylist" className="deposit">
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div className="funds me-3">
                      <ul>
                        <li className="d-none d-md-block">
                          <a href="/gatewaylist" className="deposit">
                            Deposit
                          </a>
                        </li>
                      </ul>
                    </div>
                    <Button variant="primary menu-btn" onClick={handleShow}>
                      <ProfileIcon />
                      <span>Profile</span>
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="bottom_head d-none">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul>
                  <li>
                    <a href="/casino/ezugi">
                      <img src={Casino1} alt="bottom head link icon" />
                      <span>Ezugi Games</span>
                    </a>
                  </li>

                  <li>
                    <a href="Slots">
                      <img src={Slots1} alt="bottom head link icon" />
                      <span>Slots</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/evolution">
                      <img src={Evolution} alt="bottom head link icon" />
                      <span>Evolution</span>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>

        <Offcanvas show={show} onHide={handleClose} placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <ProfileIcon />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  <a>{user?.mobileno}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-1">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.coins) || 0}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}
              >
                <Button className="btn_primary" variant="   w-100">
                  Withdraw
                </Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}
              >
                <Button className="btn_primary" variant="primary w-100">
                  Deposit
                </Button>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <ProfileIcon />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <BetIcon />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <StatementIcon />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser(true))}>
                <a href="#">
                  <LogoutIcon />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.INSTATGRAM != ""
                      ? appDetails?.INSTATGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={TelegramIcon1} alt="whatsappicon" />
                </a>
              </li>
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <span className="notification-count">2</span>
                  <img src={WhatsappIcon1} alt="whatsappicon" />
                </a>
              </li>

              <ThemeToggle />
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </header>

      <LeftMenuBar show={showLeftbar} onClose={() => setShowLeftbar(false)} />
    </>
  );
};

export default HeaderAfterLogin;
